import { useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import "./SignUp.scss";
import { auth } from "../../../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";

const SignUp = () => {
  const [checkedInput, setCheckedInput] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [copyPassword, setcopyPassword] = useState("");
  const [error, setError] = useState("");
  function register(navigate) {
    if (password !== copyPassword) {
      setError("Sorry, your password didn't match.   Please, try again");
      return;
    }
    createUserWithEmailAndPassword(auth, email, password)
      .then((user) => {
        console.log(user);
        setError("");
        setEmail("");
        setcopyPassword("");
        setPassword("");
        navigate("/main/dictionary");
      })
      .catch((err) => setError(`Password should be at least 6 characters`));
  }
  const navigate = useNavigate();

  return (
    <main className="main-signup">
      <h2>Create an account</h2>
      <form
        className="form-register"
        onSubmit={(e) => {
          e.preventDefault();
          register(navigate);
        }}
      >
        <input
          value={email}
          className="input-register"
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value)}
          type="email"
        />
        <input
          value={password}
          className="input-register"
          placeholder="Enter your password"
          onChange={(e) => setPassword(e.target.value)}
          type="password"
        />
        <input
          value={copyPassword}
          className="input-register"
          placeholder="Repeat your password"
          onChange={(e) => setcopyPassword(e.target.value)}
          type="password"
        />
        <div className="signup-agreed">
          <input
            type="checkbox"
            checked={checkedInput}
            id="input-privacy"
            onChange={() => {
              setCheckedInput(!checkedInput);
            }}
          />
          <label htmlFor="input-privacy">
            I agree with
            <Link to="/privatypolicy">
              <a className=" a-margin href-underline">Privacy Policy</a>
            </Link>
          </label>
        </div>

        <button
          className="button-main"
          disabled={checkedInput ? null : "disabled"}
        >
          Create
        </button>
        {error ? <p>{error}</p> : null}
      </form>
    </main>
  );
};
export default SignUp;
